var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFeedbackQuestion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 675,
    height: 605,
    viewBox: "0 0 675 605",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M664.939 10H10V595H664.939V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 594.5V10.5H664.439V594.5H10.5Z",
    stroke: "#BFBFBF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0605 81H665",
    stroke: "#E7E7E7",
    strokeWidth: 2.88649
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M664.393 10.557H10.4536V45.557H664.393V10.557Z",
    fill: "#1E1545"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.112,
    d: "M435.706 97.7455H23.7444V578.745H435.706V97.7455Z",
    fill: "#C6BFC4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6144 198.801H157.55V184.112H87.6144V198.801Z",
    fill: "#AFAEAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.438,
    d: "M87.6156 236.857L330.993 236.857V219.279L87.6156 219.279V236.857Z",
    fill: "#AFAEAE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.438,
    d: "M87.6147 325.549L330.684 325.549V307.972L87.6147 307.972V325.549Z",
    fill: "#AFAEAE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.438,
    d: "M87.6147 443.998L330.684 443.998V426.42L87.6147 426.42V443.998Z",
    fill: "#AFAEAE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.438,
    d: "M87.6147 295.755L330.684 295.755V278.177L87.6147 278.177V295.755Z",
    fill: "#AFAEAE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.438,
    d: "M87.6147 414.203L330.684 414.203V396.625L87.6147 396.625V414.203Z",
    fill: "#AFAEAE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.438,
    d: "M87.6147 384.449L330.684 384.449V366.871L87.6147 366.871V384.449Z",
    fill: "#AFAEAE"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.438,
    d: "M87.6147 502.897L330.684 502.897V485.319L87.6147 485.319V502.897Z",
    fill: "#AFAEAE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.438,
    d: "M87.6126 265.365H268.78V249.525L87.6126 249.525V265.365Z",
    fill: "#AFAEAE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.438,
    d: "M87.6126 354.055H268.78V338.215H87.6126V354.055Z",
    fill: "#AFAEAE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.438,
    d: "M87.6126 472.502H268.78V456.662H87.6126V472.502Z",
    fill: "#AFAEAE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.615 325.549H135.278V307.97H87.615V325.549Z",
    fill: "#FEECBC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.615 325.549H135.278V320.972H87.615V325.549Z",
    fill: "#FCC327"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8108 307.571L201.473 137.298H353.179V324.738H90.8108V307.571Z",
    fill: "url(#paint0_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M202.042 335.002L607.005 335.002V137.002L202.042 137.002V335.002Z",
    fill: "#1E1545"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M397.678 178.659C379.553 178.659 367.771 186.136 358.482 199.503C356.896 201.769 357.35 205.167 359.842 206.753L369.584 214.229C371.85 216.042 375.248 215.589 377.061 213.323C382.725 206.3 387.029 202.222 395.865 202.222C402.889 202.222 411.498 206.526 411.498 213.323C411.498 218.534 407.193 221.026 400.396 224.878C392.24 229.409 381.592 235.073 381.592 249.12V251.159C381.592 254.331 384.084 256.597 387.029 256.597H403.568C406.514 256.597 409.006 254.331 409.006 251.159V250.026C409.006 240.284 437.326 239.831 437.326 213.55C437.326 193.839 416.709 178.659 397.678 178.659ZM395.412 263.394C386.576 263.394 379.553 270.417 379.553 279.026C379.553 287.636 386.576 294.659 395.412 294.659C404.021 294.659 411.045 287.636 411.045 279.026C411.045 270.417 404.021 263.394 395.412 263.394Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M202.042 337L607.005 337V326L202.042 326V337Z",
    fill: "#CE0F69"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 674.939,
    height: 605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 481.739,
    y1: -12.0909,
    x2: 232.496,
    y2: 408.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFeedbackQuestion);
export default __webpack_public_path__ + "static/media/user-feedback-question.06e684d43b9b1caec22616b7181d731a.svg";
export { ForwardRef as ReactComponent };